import(/* webpackMode: "eager" */ "/var/www/vhosts/enterprisearmenia.am/httpdocs/frontend/src/app/[lang]/[...not-found]/page.js");
